import { GetReportProtobufAnalyticsEvent, encodeMessage } from '@ms/yammer-protobuf';

import { InfoEventName } from '../events';
import { reportTelemetryEvent } from '../report';
import { AnalyticsV2EventProps, createAnalyticsV2Event } from '../report/protobuf/createAnalyticsV2Event';
import { getTypeNameFromPackageAndEventNames } from '../report/protobuf/getTypeUrl';

import { reportInfo } from './info';

interface LoggingOptions {
  readonly eventName: string;
  readonly shouldReportErrors: boolean;
}

interface ReportUsageWithTypeNameOptions extends AnalyticsV2EventProps {
  readonly loggingOptions?: LoggingOptions;
}

interface ReportUsageOptions extends Omit<ReportUsageWithTypeNameOptions, 'typeName'> {
  readonly eventName: string;
  readonly packageName: string;
}

export type ReportUsage = (options: ReportUsageOptions) => void;
export const reportUsageV2: ReportUsage = async ({ eventName, packageName, ...rest }) => {
  const typeName = getTypeNameFromPackageAndEventNames(packageName, eventName);
  reportUsageV2WithTypeName({ ...rest, typeName });
};

export type GetReportAnalyticsEvent = (
  ...args: [...Parameters<GetReportProtobufAnalyticsEvent>, ...[loggingOptions?: LoggingOptions]]
) => ReturnType<GetReportProtobufAnalyticsEvent>;

export const getReportAnalyticsEvent: GetReportAnalyticsEvent = (MessageClass, loggingOptions) => (plainMessage) => {
  const { value, typeName } = encodeMessage(MessageClass, plainMessage);
  reportUsageV2WithTypeName({ value, typeName, loggingOptions });
};

type ReportUsageV2WithTypeName = (options: ReportUsageWithTypeNameOptions) => void;
const reportUsageV2WithTypeName: ReportUsageV2WithTypeName = async ({ loggingOptions, ...analyticsOptions }) => {
  try {
    const analyticsV2Event = await createAnalyticsV2Event(analyticsOptions);

    reportTelemetryEvent(analyticsV2Event);
  } catch (err) {
    if (loggingOptions?.shouldReportErrors) {
      reportInfo({
        eventName: InfoEventName.AnalyticsV2EventErrored,
        eventProperties: {
          errorMessage: (err as Error).message,
          name: loggingOptions.eventName,
        },
      });
    }
  }
};
